<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="userId" placeholder="请选择客户名称">
              <el-select v-model="formData.userId" filterable>
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型" prop="headerType">
              <el-select v-model="formData.headerType">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) of invoiceHeaderTypeList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="headerName">
              <el-input v-model="formData.headerName" placeholder="请输入公司名称" />
            </el-form-item>
          </el-col>
          <template v-if="formData.headerType === '2'">
            <el-col :span="12">
              <el-form-item label="税号" prop="taxNumber">
                <el-input v-model="formData.taxNumber" placeholder="请输入税号" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址" prop="headerAddress">
                <el-input v-model="formData.headerAddress" placeholder="请输入地址" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="headerPhone">
                <el-input v-model="formData.headerPhone" placeholder="请输入电话" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="bankName">
                <el-input v-model="formData.bankName" placeholder="请输入开户行" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号" prop="bankAccount">
                <el-input v-model="formData.bankAccount" placeholder="请输入开户行账号" />
              </el-form-item>
            </el-col>
          </template>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { validPhoneNumber } from '@/utils/validator'
import { invoiceHeaderType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'
export default {
  name: 'InvoiceTitleAdd',
  data() {
    return {
      userList: [],
      invoiceHeaderTypeList: mapToObjectArray(invoiceHeaderType),
      formData: {
        headerType: '', // 抬头类型
        userId: '', // 关联客户id
        headerName: '', // 名称
        headerAddress: '', // 地址
        headerPhone: '', // 电话
        taxNumber: '', // 税号
        bankName: '', // 开户行
        bankAccount: '' // 开户行账号
      },
      rules: {
        userId: [{ required: true, message: '请选择客户名称', trigger: ['change', 'blur'] }],
        headerType: [{ required: true, message: '请选择抬头类型', trigger: ['change', 'blur'] }],
        headerName: [{ required: true, message: '请输入名称', trigger: ['change', 'blur'] }],
        taxNumber: [{ required: true, message: '请输入税号', trigger: ['change', 'blur'] }],
        headerPhone: [
          { validator: validPhoneNumber, message: '请输入正确的手机号', trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed: {
    headerId() {
      return this.$route.query.headerId
    }
  },
  created() {
    this.loadUserList()
    if (this.headerId) {
      this.loadDetails()
    }
  },
  methods: {
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceHeaderByHeaderId, {
        params: { headerId: this.headerId }
      }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.lyInvoice.insertLyInvoiceHeader
        if (this.headerId) {
          url = this.$apis.lyInvoice.updateLyInvoiceHeader
        }
        this.$axios.post(url, this.formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
